<template>
  <div class="evaluation-wrap">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'EvaluationIndex'
}
</script>

<style lang="less" scoped>
.evaluation-wrap {
  width: 100%;
  height: 100%;
}
</style>
